var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{ref:"vue-root",attrs:{"id":"app"}},[_c('header',[_c('div',{class:_vm.headerStyle(),attrs:{"id":"inner_header"}},[_c('SpendeAppLogo',{staticClass:"label_logo"})],1)]),_c('main',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }